import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import VueMeta from 'vue-meta'
import './assets/tailwind.css'

Vue.config.productionTip = false
Vue.use(VueMeta)

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
